<template>
  <footer class="ftn-footer">
    <div class="ftn-container">
      <div class="ftn-footer__header">
        <router-link
          :to="{ name: 'Homepage' }"
          class="ftn-footer__logo"
        >
          <img
            loading="lazy"
            src="@/assets/icons/optimized/tryb_light.webp"
            alt=""
          >
        </router-link>

        <span>&#169; {{ currentYear }} Tryb Media Limited</span>
      </div>

      <section class="ftn-footer__lists">
        <div class="ftn-footer__col details">
          <div class="ftn-footer__col-heading details__summary">Company</div>
          <ul class="details__body">
            <li>
              <router-link :to="{ name: 'About' }">About Us</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Privacy' }">
                Privacy
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Terms' }">
                Terms
              </router-link>
            </li>
          </ul>
        </div>

        <div class="ftn-footer__col details">
          <div class="ftn-footer__col-heading details__summary">Help &#38; Support</div>
          <ul class="details__body">
            <li>
              <span @click="handleChatWithUsClick">Chat with us</span>
            </li>
            <li>
              <router-link :to="{ name: 'ContactUs' }">
                Email
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'FAQ' }">
                FAQ's
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Profile', params: { username: 'creatorresources' } }">
                Creator Resources
              </router-link>
            </li>
          </ul>
        </div>

        <div class="ftn-footer__col details">
          <div class="ftn-footer__col-heading details__summary">
            Socials
          </div>
          <ul class="details__body">
            <li
              v-for="(social, i) in socials"
              :key="i"
            >
              <a
                :href="social.href"
                target="_blank"
                rel="noopener"
              >
                <img
                  :src="social.icon"
                  :alt="social.name"
                  aria-hidden="true"
                  width="16"
                  height="16"
                >
                {{ social.name }}
              </a>
            </li>
          </ul>
        </div>
      </section>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      currentYear: new Date().getFullYear(),
      detailsButtons: [],
      socials: [
        {
          icon: require('@/assets/icons/optimized/brands/facebook_grey.svg'),
          href: 'https://www.facebook.com/Food-Tryb-370175540378551/?modal=admin_todo_tour',
          name: 'Facebook',
        },
        {
          icon: require('@/assets/icons/optimized/brands/twitter_grey.svg'),
          href: 'https://twitter.com/tryb_cc',
          name: 'X (Twitter)',
        },
        {
          icon: require('@/assets/icons/optimized/brands/tiktok_grey.svg'),
          href: 'https://www.tiktok.com/@tryb.cc?lang=en',
          name: 'TikTok',
        },
        {
          icon: require('@/assets/icons/optimized/brands/instagram_grey.svg'),
          href: 'https://www.instagram.com/tryb.cc/',
          name: 'Instagram',
        },
      ],
    };
  },
  mounted() {
    this.detailsButtons = this.$el.querySelectorAll('.details__summary');

    this.detailsButtons.forEach((button) => {
      button.addEventListener('click', this.listener);
    });
  },
  beforeDestroy() {
    this.detailsButtons.forEach((button) => {
      button.removeEventListener('click', this.listener);
    });
  },
  methods: {
    listener({ currentTarget }) {
      currentTarget.classList.toggle('details__summary_open');
      const body = currentTarget.nextElementSibling;
      // eslint-disable-next-line no-unused-expressions
      body.style.maxHeight
        ? body.style.maxHeight = ''
        : body.style.maxHeight = `${body.scrollHeight + 8}px`;
    },
    handleChatWithUsClick() {
      window.$zoho.salesiq.floatwindow.visible('show');
    },
  },
};
</script>
